import React from 'react';
import './SelectedCandidates.css';
import UserAvatar from 'react-user-avatar';
import ConsoleLog from './../../../../hoc/ConsoleLog/ConsoleLog';

const Initials = (props) => {
  const initialColor=['#E0E9F2', '#C9EDE6', '#C4CAD0', '#F4ADAE', '#E9D7D8', '#EAC0CE'];

	return ( <UserAvatar className="UserAvatar-light" name={props.initials?props.initials:'--'} colors={initialColor}/> );
}

const SelectedCandidates = (props) => {

  const userType = props.userType?props.userType: null;
  let content = "";
  ConsoleLog("Canidates selected are: ", props.candidates);
  /* For recruiter View */
  if(userType === 3)
    {
      content = props.candidates.length >0 ? props.candidates.map((candidate) =>  
        {
          const image = candidate.s3SignedUrl?
                          (<img src={candidate.s3SignedUrl}/>):
                          (<Initials initials={candidate.initials} />)
          return(            
          <li className="rec-selected-candidate">
            {/* <div > */}
              <div className="selected-candidate-info-main">
                {image}
                <div className="selected-candidate-info">
                  <p className="selected-candidate-name">
                    <span>
                      {candidate.candidate_fname+ " "+ candidate.candidate_lname}
                    </span>
                  </p>
                  <p className="selected-candidate-bhidlabel">BH ID 
                    <span className="selected-candidate-bhid">{" "+candidate.bh_id}
                    </span>
                  </p>
                  <p className="selected-candidate-email">{candidate.email}</p>
                </div>
              </div>
            {/* </div> */}
          </li>
            
          )
        }): "";
    } 
  else 
    {
      content = props.candidates.length >0 ? props.candidates.map((candidate) =>
        {
          const image = candidate.s3SignedUrl?
                          (<img src={candidate.s3SignedUrl}/>):
                          (<Initials initials={candidate.initials} />)
          return(
            <li className="client-selected-candidate">
              {image}
              {candidate.candidate_fname+ " "+ candidate.candidate_lname}
            </li>
          )
        }): "";
    }

  return(
    <div className="candidates-selected">
      <h4>Candidates selected for interview</h4>
      <ul>
        {content}
      </ul>
    </div>
  );
}

export default SelectedCandidates;


// WEBPACK FOOTER //
// ./src/components/Client/ClientInterviewSchedular/SelectedCandidates/SelectedCandidates.js